import React from 'react';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import {extractSlugLocale} from '@epic-core/localization';
import {getInitialCmsPageSharedValues, getUrlPattern, PageData, useCmsData} from 'epic-ue-shared';
import {PathMatch, useLocation, useMatch} from 'react-router';
import {getLocale} from '@epic-core/common';
import {getNoTrailingSlash} from '@epic-mw/common-utils';
import Error404 from '../error/Error404';

const getCmsUrlPattern = (match: PathMatch | null) => {
    if (!match) return '';
    return getUrlPattern(match);
};

interface FaqPageData extends PageData {
    content: string;
}

const EpicFaqView = (): JSX.Element => {
    const {pathname} = useLocation();
    const match = useMatch(pathname);
    const cmsUrlPattern = getCmsUrlPattern(match);
    const {cmsLoading, cmsLoadedEmpty, pageData} = useCmsData<FaqPageData>(cmsUrlPattern);

    if (cmsLoading) {
        return (
            <div className="faq-view" key="faq-view">
                <LoadIndicator key="faq-view-loading" />
            </div>
        );
    }

    if (cmsLoadedEmpty) {
        return <Error404 />;
    }

    if (!pageData || !pageData._id) {
        return (
            <div className="faq-view" key="faq-view">
                <LoadIndicator key="faq-view-loading" />
            </div>
        );
    }

    const {content} = pageData;

    if (!content) {
        return <Error404 />;
    }

    return (
        <div className="faq-view">
            {getHelmetForMetaTags(pageData)}
            <div className="content-container container">
                <div className="faq-content-wrap">
                    <div className="faq-content" dangerouslySetInnerHTML={{__html: content}} />
                </div>
            </div>
        </div>
    );
};

EpicFaqView.getInitialSharedValues = getInitialCmsPageSharedValues();

export default EpicFaqView;
